import React from 'react'
import { Link } from 'react-router-dom'
import { useUserProfile } from '../../Hook/App'
import Layout from '../../Layout'
import HeaderMain from '../../Components/HeaderMain'
import Comments from './Components/Comments'
import Information from './Components/Information'
import Products from './Components/Products'
function Index() {
    const { tab, setTab, loading, userProducts, userComments, user } = useUserProfile()
    const { userProducts: loadProducts, userComments: loadComments } = loading;
    return (
        <Layout>
            <HeaderMain lable="پروفایل" leftitem={<div className="left d-flex">
                <Link to={"/EditProfile"}><i className="fas fa-pen"></i></Link>
            </div>} />
            <div className='profile-top'>
                <div className="profile-main">
                    <Information user={user} comments={userComments || []} products={userProducts || []} />
                    <div className="d-flex">
                        <button onClick={() => setTab("items")} style={tab == "items" ? { borderBottomColor: "#7367f0" } : { border: "none" }} className='advertising-title'>
                            آگهی ها
                        </button>
                        <button onClick={() => setTab("comments")} style={tab == "comments" ? { borderBottomColor: "#7367f0" } : { border: "none" }} className='advertising-title'>
                            نظر های کاربران
                        </button>
                    </div>
                </div>
            </div>
            <div className='mt-3'>
                {tab == "comments" && <Comments loading={loadComments} comments={userComments || []} replay={() => {}} />}
            
                {tab == "items" && <Products loading={loadProducts} items={userProducts || []} />}
            
            </div>
         
        </Layout>
    )
}
export default Index